import { api } from './networkService';

class PostService {
    static async fetch(page, filters) {
        try {
            const response = await api.get(`api/user/post`, {
                params: {
                    page: page,
                    perPage: 20,
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch post error:', error);
            throw error;
        }
    }

    static async fetchAll(filters) {
        try {
            const response = await api.get(`api/user/post`, {
                params: filters
            });
            return response.data;
        } catch (error) {
            console.error('Fetch post error:', error);
            throw error;
        }
    }

    static async fetchByDriver(filters) {
        try {
            const response = await api.get(`api/user/post/by/driver`, {
                params: {
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch post error:', error);
            throw error;
        }
    }

    static async fetchByPage(filters) {
        try {
            const response = await api.get(`api/user/post/by/page`, {
                params: {
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch post error:', error);
            throw error;
        }
    }

    static async sendPostToPrint(postId) {
        try {
            const response = await api.get(`api/user/post/send/${postId}`);
            return response.data;
        } catch (error) {
            console.error('Send post error:', error);
            throw error;
        }
    }

    static async sendPostToPrintMultiple(filters) {
        try {
            const response = await api.get(`api/user/post/send/multiple/posts`, {
                params: {
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Send post error:', error);
            throw error;
        }
    }

    static async fetchForDriverPayment(filters) {
        try {
            const response = await api.get(`api/user/post/for/driver-payment`, {
                params: {
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch post error:', error);
            throw error;
        }
    }

    static async fetchForPagePayment(filters) {
        try {
            const response = await api.get(`api/user/post/for/page-payment`, {
                params: {
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch post error:', error);
            throw error;
        }
    }

    static async fetchOne(id) {
        try {
            const response = await api.get(`api/user/post/${id}`);
            return response.data;
        } catch (error) {
            console.error('Fetch post error:', error);
            throw error;
        }
    }


    static async checkByPageAndPhone(pageId, phone) {
        try {
            const response = await api.get(`api/user/post/check/recent`, {
                params: {
                    pageId,
                    phone
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch post error:', error);
            throw error;
        }
    }

    static async add(post) {
        try {
            const cleanedPost = Object.fromEntries(
                Object.entries(post).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
            );
            const response = await api.post(`api/user/post`, cleanedPost);
            return response;
        } catch (error) {
            console.error('Add post error:', error);
            throw error;
        }
    }

    static async fetchAllPostStatuses() {
        try {
            const response = await api.get(`api/user/post/post-status/all`);
            return response.data;
        } catch (error) {
            console.error('Fetch post status error:', error);
            throw error;
        }
    }


    static async update(id, post) {
        try {
            const cleanedPost = Object.fromEntries(
                Object.entries(post).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
            );
            const response = await api.put(`api/user/post/${id}`, cleanedPost);
            return response;
        } catch (error) {
            console.error('Update post error:', error);
            throw error;
        }
    }

    static async updatePostStatus(id, post) {
        try {
            const cleanedPost = Object.fromEntries(
                Object.entries(post).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
            );
            const response = await api.put(`api/user/post/post-status/update/${id}`, cleanedPost);
            return response;
        } catch (error) {
            console.error('Update post status error:', error);
            throw error;
        }
    }

    static async updateMultiple(posts) {
        try {
            const cleanedPosts = Object.fromEntries(
                Object.entries(posts).filter(([_, value]) => value && value !== '')
            );
            const response = await api.put(`api/user/post/update/multiple`, cleanedPosts);
            return response;
        } catch (error) {
            console.error('Update post error:', error);
            throw error;
        }
    }

    static async updateChangeStatus(id, changeStatus) {
        try {
            const response = await api.put(`api/user/post/update-change-status/${id}`, {
                changeStatus
            });
            return response;
        } catch (error) {
            console.error('Update post error:', error);
            throw error;
        }
    }

}

export default PostService;
